// 英文
const userModule = {
  user: "My",
  userName: "Name",
  userInfo: "User information",
  phone: "Contact number",
  sex: "Sex",
  updatePassword: "Update password",
  myOrder: "My Order",
  myCoupon:"Coupon",
  aboutService: "About service",
  rule1: "Terms of use",
  rule2: "Protection policy",
  returnLogin: "Exit",
  sex0: "Keep secret",
  sex1: "Male",
  sex2: "Female",
  email: "Email",
};
export default userModule;